import{unstable_deprecatedPropType as _0x307e67}from'@mui/utils';export default _0x307e67;